import { Table } from '@mantine/core';
import { ICurrency } from '../../../../libraries/currencies';
import { Transaction } from '../../../../libraries/transactions';
import { Language } from '../../../languages/languageHandler';
import { formatCurrAmount } from '../../../utils/script';
import { useSelector } from 'react-redux';
import { AppState } from '../../../client-redux/reducers';
import './styles.scss';

interface Props {
  currency?: ICurrency;
  amount: number;
  cumulativeExcess: number;
  prevCumulativeExcess: number;
  cashCollectionData?: Transaction['cashCollectionData'];
}

const PeriodsTable = ({ currency, cashCollectionData, amount, prevCumulativeExcess }: Props) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  let remaining = amount;

  return (
    <div>
      <Table.ScrollContainer minWidth={500}>
        <Table className="transaction-table" withColumnBorders withTableBorder striped>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{lang.GLOBAL_PERIOD}</Table.Th>
              <Table.Th>{lang.GLOBAL_STATE}</Table.Th>
              <Table.Th>{lang.GLOBAL_TOTAL_INVOICED}</Table.Th>
              <Table.Th>{lang.GLOBAL_TOTAL_COLLECTED_PREVIOUS}</Table.Th>
              <Table.Th>{lang.GLOBAL_TOTAL_COLLECTED_RESPECTIVE}</Table.Th>
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {cashCollectionData?.periods.map((period, index) => {
              let prevCollectedAmount = Math.min(prevCumulativeExcess, period.paidCash) - period.loaded;
              prevCumulativeExcess = Math.max(prevCumulativeExcess - period.paidCash, 0);

              let collectedAmount = period.paidCash - prevCollectedAmount;
              if (collectedAmount <= 0) {
                collectedAmount = 0;
              } else {
                collectedAmount = Math.max(Math.min(collectedAmount, remaining), 0);
              }
              remaining -= collectedAmount;

              return (
                <Table.Tr key={index}>
                  <Table.Td>{period.period}</Table.Td>
                  <Table.Td>{period.open ? lang.GLOBAL_PERIOD_STATE_OPEN : lang.GLOBAL_PERIOD_STATE_CLOSED}</Table.Td>
                  <Table.Td>{currency ? formatCurrAmount(period.paidCash || 0, currency) : '-'}</Table.Td>
                  <Table.Td>
                    {prevCollectedAmount === 0 ? '-' : currency ? formatCurrAmount(prevCollectedAmount, currency) : '-'}
                  </Table.Td>
                  <Table.Td>{currency ? formatCurrAmount(collectedAmount, currency) : '-'}</Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </div>
  );
};

export default PeriodsTable;
